import styled from 'styled-components';
import {
  Table as SemanticTable,
  Modal as SemanticModal, Input as SemanticInput,
  Message as SemanticMessage,
} from 'semantic-ui-react';

import {
  Loader as LoaderLayoutComponent,
  Text as TextLayoutComponent,
  Button as ButtonLayoutComponent,
  Header,
} from '@playbookux/playbook-web-core';

export const UsageHeader = styled.div`
   display: flex;
   justify-content: space-between;
   margin-bottom: 25px;
   margin-top: 25px;
`;

export const Title = styled(Header)`
  margin-bottom: 5px;
`;

export const ButtonEntry = styled(ButtonLayoutComponent)`
  margin-right: 85px !important;
`;

export const Table = styled(SemanticTable)`
  border: 1px solid #e0e0e0;
`;
export const TableHeaderSmall = styled(SemanticTable.HeaderCell)`
  width: 25%;
`;

export const TableHeaderLarge = styled(SemanticTable.HeaderCell)`
  width: 50%;
`;

export const Text = styled(TextLayoutComponent)``;

export const Status = styled.div`
  display: flex;
  gap: 10px;
`;

export const TableText = styled(TextLayoutComponent)`
  font-size: 14px;
  line-height: 20px;
  `;

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const CellBorderRight = styled(SemanticTable.Cell)`
  border-right: 1px solid #e0e0e0;
`;

export const CellBorderLeft = styled(SemanticTable.Cell)`
  border-left: 1px solid #e0e0e0;
`;

export const Loader = styled(LoaderLayoutComponent)`
`;

export const DefaultText = styled(TextLayoutComponent.Success)`
`;

export const Link = styled.a``;

export const Modal = styled(SemanticModal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &.ui.modal > .content,
  &.ui.modal > .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
`;

export const Input = styled(SemanticInput)`
`;

export const Button = styled(ButtonLayoutComponent)`
`;

export const Message = styled(SemanticMessage)`
`;
